import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { ProductMockup } from '../ProductMockup';
import { PurchaseButton } from '../PurchaseButton';
import { PriceTag } from '../PriceTag';
import { offerIncludes } from '../../data/overview';
import { siteConfig } from '../../data/config';
export function Offer() {
  return <section id="offer" className="scroll-mt-4 bg-charcoal text-ivory" data-id="element-146" data-mp="357nidpj3hsmp">
      <div className="mx-auto max-w-site px-5 py-20 md:px-8 lg:py-28" data-id="element-147" data-mp="3a4dyudytaq8n">
        <div className="text-center" data-id="element-148" data-mp="3f49yk10h7vie">
          <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-copper" data-id="element-149" data-mp="3f38mpubmz4zm">The Complete Offer</p>
          <h2 className="mx-auto mt-4 max-w-[760px] font-display text-[34px] font-bold leading-[1.08] lg:text-[48px]" data-id="element-150" data-mp="3jvrzwq6evy3w">
            The complete Diesel Fault Atlas collection.
          </h2>
        </div>

        <div className="mt-14 grid items-center gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-14" data-id="element-151" data-mp="3sxrllvsdfqd6">
          <div className="rounded-[8px] border border-white/[0.06] bg-graphite px-6 pb-4 pt-8 sm:px-10" data-id="element-152" data-mp="1q5e1s2j73r1">
            <ProductMockup className="mx-auto max-w-[520px]" data-id="element-153" data-mp="1kmrreqbttwe5" />
          </div>

          <div data-id="element-154" data-mp="1fllwclup1x1g">
            <div id="purchase-panel" className="rounded-[10px] bg-ivory p-6 text-ink shadow-[0_24px_60px_rgba(0,0,0,0.4)] ring-2 ring-amber sm:p-10" data-id="element-155" data-mp="1fl2awv5u4qio">
              <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-copperDeep" data-id="element-156" data-mp="16m8ilgzjemax">Everything included</p>
              <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-157" data-mp="23awpbh5syn51">
                {offerIncludes.map(i => <li key={i} className="flex items-start gap-3 text-[16px] leading-snug" data-id="element-158" data-mp="1zaw8xqz581vc">
                    <CheckIcon className="mt-[2px] h-4 w-4 shrink-0 text-tealDeep" strokeWidth={3} aria-hidden="true" data-id="element-159" data-mp="1uicvcu0gh6qj" />
                    {i}
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-rule pt-7" data-id="element-160" data-mp="2n1i62n7m01qk">
                <PriceTag size="lg" data-id="element-161" data-mp="2i8p0xy88ardy" />
                {siteConfig.paymentTerms && <p className="mt-2 text-[15px] text-inkSoft" data-id="element-162" data-mp="2i7dyq2uflroy">{siteConfig.paymentTerms}</p>}
              </div>

              <PurchaseButton mode="checkout" label="Buy Diesel Fault Atlas" fullWidth className="mt-6" data-id="element-163" data-mp="364kabsd8rs32" />

              <p className="mt-4 text-[14px] leading-relaxed text-inkSoft" data-id="element-164" data-mp="2sdf6sf6r6fng">
                Digital reference collection. No physical books or diagnostic equipment are shipped.
                {siteConfig.deliveryDetails && ` ${siteConfig.deliveryDetails}`}
              </p>
            </div>

            {siteConfig.guaranteeTerms && <div className="mt-5 flex gap-4 rounded-[8px] border border-white/10 bg-graphite p-5" data-id="element-165" data-mp="2neviw98lmtsg">
                <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-166" data-mp="29fme05pufm3s" />
                <p className="text-[15px] leading-[1.6] text-mist" data-id="element-167" data-mp="2dgo8yacq9bzy">{siteConfig.guaranteeTerms}</p>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}